import { matchTrackerApi, metricsServerApi } from '../../modules/servers/api'
import { createCrudEndpoints } from '../api'
import { handleSetPitchInUse } from './slice'
import {
  AutoLocateRequestData,
  PitchTypes,
  TotalStationRequestBody
} from './types'

export const pitchesMetricsServerApi = metricsServerApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get pitch config
    getPitchConfig: builder.query<PitchTypes, void>({
      query: () => ({
        url: 'api/config/pitch',
        method: 'GET',
        withCredentials: true
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const response = await queryFulfilled
          dispatch(handleSetPitchInUse(response.data))
        } catch (error) {
          dispatch(handleSetPitchInUse(null))
        }
      },
      providesTags: ['pitches']
    }),

    // Set pitch config
    setPitchConfig: builder.mutation<PitchTypes, string>({
      query: (pitchId) => ({
        url: 'api/config/pitch',
        method: 'POST',
        body: { id: pitchId },
        withCredentials: true
      }),
      invalidatesTags: ['pitches']
    }),

    // Auto locate
    autoLocate: builder.mutation<PitchTypes, AutoLocateRequestData>({
      query: (data) => ({
        url: 'api/config/autolocate',
        method: 'POST',
        body: data,
        withCredentials: true
      }),
      invalidatesTags: ['pitches']
    }),

    // Total station pitch/anchor setup
    postAnchorPitchSetup: builder.mutation<PitchTypes, TotalStationRequestBody>(
      {
        query: (body) => {
          return {
            url: 'api/config/total_station',
            method: 'POST',
            body,
            withCredentials: true
          }
        },
        invalidatesTags: ['pitches']
      }
    )
  }),
  overrideExisting: false // make sure not to override unless needed
})

export const pitchesMatchTrackerApi = matchTrackerApi.injectEndpoints({
  endpoints: (builder) => ({
    // Generic CRUD endpoints //
    ...createCrudEndpoints<PitchTypes>('pitches', builder)
  })
})

export const {
  usePitches_getAllQuery,
  usePitches_getByIdQuery,
  useLazyPitches_getAllQuery,
  usePitches_createMutation
} = pitchesMatchTrackerApi

export const {
  getPitchConfig,
  setPitchConfig,
  autoLocate,
  postAnchorPitchSetup
} = pitchesMetricsServerApi.endpoints

export const { useLazyGetPitchConfigQuery } = pitchesMetricsServerApi
